import React from 'react';
import { CalendarClock, BarChart3, Flame, Trophy } from 'lucide-react';
import { features } from '../mock';

const iconMap = { CalendarClock, BarChart3, Flame, Trophy };

const StatsStrip = () => {
  return (
    <section className="bg-[#F5EDE0] text-[#2A1810]">
      <div className="max-w-7xl mx-auto px-4 sm:px-5 lg:px-8 py-8 sm:py-10 grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
        {features.map((f) => {
          const Ico = iconMap[f.icon];
          return (
            <div key={f.title} className="text-center px-1 sm:px-2 group">
              <div className="mx-auto h-11 w-11 sm:h-14 sm:w-14 rounded-2xl grid place-items-center bg-[#F4C430]/15 border border-[#F4C430]/40 group-hover:bg-[#F4C430]/25 transition-colors">
                <Ico size={20} className="text-[#8a5a1e]" />
              </div>
              <h4 className="mt-3 sm:mt-4 font-serif text-base sm:text-xl text-[#2A1810]">{f.title}</h4>
              <p className="mt-1 text-xs sm:text-sm text-[#6b4a2b] max-w-[220px] mx-auto">{f.desc}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default StatsStrip;
